<template>
	<div class="divBox" style="text-align: left">
		<el-card class="box-card">
			<el-form inline size="small" @submit.native.prevent>
				<el-form-item label="客户姓名">
					<el-input v-model="listPram.customerName" placeholder="客户姓名" clearable maxlength="30"></el-input>
				</el-form-item>
				<el-form-item label="联系方式">
					<el-input v-model="listPram.contactInfo" placeholder="联系方式" clearable maxlength="30"></el-input>
				</el-form-item>
				<el-form-item label="线索类型">
					<el-select v-model="listPram.leadType" filterable clearable placeholder="请选择线索类型">
						<el-option
							v-for="item in leadTypeDict"
							:label="item.name"
							:value="item.itemCode"
							:key="item.itemCode"></el-option>
					</el-select>
				</el-form-item>
				<template v-if="showMore">
					<el-form-item label="线索来源">
						<el-select v-model="listPram.leadSource" filterable clearable placeholder="请选择线索状态">
							<el-option
								v-for="item in leadSourceDict"
								:label="item.name"
								:value="item.itemCode"
								:key="item.itemCode"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="线索状态">
						<el-select v-model="listPram.clueStatus" filterable clearable placeholder="请选择线索状态">
							<el-option
								v-for="item in clueStatusDict"
								:label="item.name"
								:value="item.itemCode"
								:key="item.itemCode"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="需求类型">
						<el-select v-model="listPram.demandType" filterable clearable placeholder="请选择需求类型">
							<el-option
								v-for="item in demandTypeDict"
								:label="item.name"
								:value="item.itemCode"
								:key="item.itemCode"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="跟进记录">
						<el-select v-model="listPram.consumptionWillingness" filterable clearable placeholder="请选择跟进记录">
							<el-option
								v-for="item in consumptionWillingnessDict"
								:label="item.name"
								:value="item.itemCode"
								:key="item.itemCode"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="跟进人">
						<el-select v-model="listPram.followUpPersonId" filterable clearable placeholder="请选择跟进人">
							<el-option
								v-for="item in followUserList"
								:label="item.realName"
								:value="item.id"
								:key="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="创建人">
						<el-select v-model="listPram.createPersonId" filterable clearable placeholder="请选择客户等级">
							<el-option
								v-for="item in followUserList"
								:label="item.realName"
								:value="item.id"
								:key="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="最后跟进时间">
						<el-date-picker
							v-model="lastFollowTime"
							type="daterange"
							placeholder="选择跟进时间"
							range-separator="至"
							start-placeholder="起始时间"
							end-placeholder="结束时间"
							clearable
							value-format="yyyy-MM-dd"
							@change="handleLastFollowTimeChange"></el-date-picker>
					</el-form-item>
					<el-form-item label="线索创建日期">
						<el-date-picker
							v-model="createTime"
							type="daterange"
							placeholder="选择创建日期"
							range-separator="至"
							start-placeholder="起始日期"
							end-placeholder="结束日期"
							clearable
							value-format="yyyy-MM-dd"
							@change="handleCreateTimeChange"></el-date-picker>
					</el-form-item>
				</template>
				<el-form-item>
					<el-button size="mini" type="primary" @click="showMore = !showMore">
						{{ showMore ? '收起' : '更多' }}
					</el-button>
					<el-button size="mini" type="primary" @click="handleSearch">查询</el-button>
					<el-button size="mini" type="primary" @click="resetForm">重置</el-button>
				</el-form-item>
			</el-form>

			<el-form inline @submit.native.prevent>
				<el-form-item style="width: 100%; text-align: right">
					<el-button size="mini" type="primary" @click="handlerOpenAdd(0)">+ 添加线索</el-button>
					<el-button size="mini" type="primary" @click="bulkImport">+批量导入</el-button>
				</el-form-item>
			</el-form>

			<el-table id="baseTable" v-loading="listLoading" :height="tableHeight" :data="listData.list" size="mini">
				<el-table-column type="index" label="序号" width="50" align="center" />
				<el-table-column label="客户姓名" prop="customerName" min-width="120" align="center" />
				<el-table-column label="联系方式" prop="contactInfo" min-width="150" align="center" />
				<el-table-column label="需求类型" prop="demandTypeDesc" min-width="100" align="center" />
				<el-table-column label="线索类型" prop="leadTypeDesc" min-width="100" align="center" />
				<el-table-column label="线索来源" prop="leadSourceDesc" min-width="100" align="center">
					<template slot-scope="scope">
						{{ scope.row.leadSourceDesc || '-' }}
					</template>
				</el-table-column>
				<el-table-column label="跟进记录" prop="consumptionWillingnessDesc" min-width="140" align="center">
					<template slot-scope="scope">
						<el-tag
							v-if="scope.row.consumptionWillingnessDesc"
							:type="getConsumptionWillingnessTagType(scope.row.consumptionWillingness)"
							size="small">
							{{ scope.row.consumptionWillingnessDesc }}
						</el-tag>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column label="线索状态" prop="clueStatusDesc" min-width="100" align="center" />
				<el-table-column label="跟进记录" prop="followUpRecord" min-width="100" align="center">
					<template slot-scope="scope">
						<el-button type="text" size="mini" @click="handlerOpenDetail(scope.row, 1)">跟进记录</el-button>
					</template>
				</el-table-column>
				<el-table-column label="最近一次跟进结果" prop="followUpRecord" min-width="120" align="center">
					<template slot-scope="scope">
						<el-tooltip class="item" effect="dark" :content="scope.row.followUpRecord" placement="top">
							<div class="remarks-text" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
								{{ scope.row.followUpRecord || '-' }}
							</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column label="跟进人" prop="followUpPersonName" min-width="100" align="center" />
				<el-table-column label="最后跟进时间" prop="lastFollowTime" min-width="150" align="center">
					<template slot-scope="scope">
						{{ scope.row.lastFollowTime || '-' }}
					</template>
				</el-table-column>
				<el-table-column label="创建人" prop="createPersonName" min-width="100" align="center" />
				<el-table-column label="线索创建日期" prop="createTime" min-width="150" align="center" />
				<el-table-column label="备注" prop="remarks" min-width="200" align="center">
					<template slot-scope="scope">
						<el-tooltip class="item" effect="dark" :content="scope.row.remarks" placement="top">
							<div class="remarks-text" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
								{{ scope.row.remarks || '-' }}
							</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column label="操作" min-width="100" fixed="right">
					<template slot-scope="scope">
						<el-button type="text" size="mini" @click="handlerOpenDetail(scope.row, 0)">详情</el-button>
						<!-- 更多 -->
						<el-dropdown>
							<el-button type="text" size="mini">
								更多
								<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item
									:disabled="!saleManager && scope.row.followUpPersonId != userInfo.id"
									split-button
									@click.native="handlerOpenAdd(1, scope.row)">
									<span>编辑线索</span>
								</el-dropdown-item>
								<el-dropdown-item
									:disabled="!saleManager && scope.row.followUpPersonId != userInfo.id"
									split-button
									@click.native="handlerDestroy(scope.row)">
									<span>销毁线索</span>
								</el-dropdown-item>
								<el-dropdown-item
									:disabled="(!saleManager && scope.row.followUpPersonId != userInfo.id) || scope.row.clueStatus == 4"
									split-button
									@click.native="handlerInvalid(scope.row)">
									<span>线索失效</span>
								</el-dropdown-item>
								<el-dropdown-item
									:disabled="!saleManager && scope.row.followUpPersonId != userInfo.id"
									split-button
									@click.native="handlerOpenOrder(scope.row)">
									<span>发起订单</span>
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination
				:current-page="listPram.page"
				:page-sizes="constants.page.limit"
				:layout="constants.page.layout"
				:total="listData.total"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange" />
		</el-card>

		<!-- 线索详情 -->
		<el-dialog
			:title="title"
			center
			:close-on-click-modal="false"
			:visible.sync="clueDialogConfig.visible"
			@close="clueDialogConfig.type == 1 ? hideDialog() : ''">
			<clueDetail
				v-if="clueDialogConfig.visible"
				:edit-data="clueDialogConfig.editData"
				:type="clueDialogConfig.type"
				:consumptionWillingnessDict="consumptionWillingnessDict"
				@hideDialog="hideDialog" />
		</el-dialog>

		<!-- 新增、编辑线索 -->
		<el-dialog
			:title="clueDialogCreateConfig.isCreate === 1 ? '编辑线索' : '新增线索'"
			:close-on-click-modal="false"
			:visible.sync="clueDialogCreateConfig.visible">
			<create
				v-if="clueDialogCreateConfig.visible"
				:is-create="clueDialogCreateConfig.isCreate"
				:edit-data="clueDialogCreateConfig.editData"
				@hideDialogCreate="hideDialogCreate"
				:demandTypeDict="demandTypeDict"
				:consumptionWillingnessDict="consumptionWillingnessDict"
				:leadTypeDict="leadTypeDict"
				:leadSourceDict="leadSourceDict" />
		</el-dialog>

		<el-dialog title="批量导入线索" :close-on-click-modal="false" :visible.sync="bulkImportDialogVisible">
			<bulk-import
				v-if="bulkImportDialogVisible"
				@closeDialog="closeBulkImportDialog"
				@importSuccess="handleImportSuccess"></bulk-import>
		</el-dialog>
	</div>
</template>

<script>
	// import * as clueApi from '@/api/clueNew'
	import create from './create';
	import clueDetail from './clueDetail';
	import bulkImport from './bulkImport';
	import tableHeightMixins from '@/mixins/tableHeightMixins';
	import { getDictionaryByCode } from '@/utils/dict';
	import Cookies from 'js-cookie';
	// import { hasSaleManager } from '@/api/clueNew';

	export default {
		mixins: [tableHeightMixins],

		// name: 'clueManage',
		components: { clueDetail, create, bulkImport },
		filters: {
			transName(val, valList) {
				const _valList = valList || [];
				const tarObj = _valList.find(item => {
					return item.value == val;
				});
				if (tarObj) {
					return tarObj.name;
				}
			},
		},
		data() {
			return {
				listLoading: false,
				showMore: false,
				demandTypeDict: [], // 需求类型
				consumptionWillingnessDict: [], // 跟进记录
				leadTypeDict: [], // 线索类型
				clueStatusDict: [], // 线索状态
				leadSourceDict: [], // 线索来源
				lastFollowTime: [], // 最后跟进时间
				createTime: [], // 线索创建日期
				saleManager: false,
				userInfo: JSON.parse(Cookies.get('JavaInfo') || '{}'),
				title: '',
				listPram: {
					customerName: '',
					page: 1,
					limit: this.$constants.page.limit[0],
				},
				clueDialogConfig: {
					visible: false,
					editData: {},
					type: 0,
				},
				clueDialogCreateConfig: {
					visible: false,
					editData: {},
					title: '',
					isCreate: 0,
				},
				constants: this.$constants,
				listData: {
					list: [
						{
							customerName: '张三',
							contactInfo: '13800138000',
							demandTypeDesc: '租赁需求',
							leadTypeDesc: '新线索',
							leadSourceDesc: '线上推广',
							consumptionWillingness: 3,
							consumptionWillingnessDesc: '高意向',
							clueStatus: 1,
							clueStatusDesc: '跟进中',
							followUpRecord: '客户对价格敏感，需进一步沟通优惠方案',
							followUpPersonId: 101,
							followUpPersonName: '李销售',
							lastFollowTime: '2026-04-15 14:30:00',
							createPersonName: '王经理',
							createTime: '2026-04-10 10:00:00',
							remarks: '首次沟通较顺利，有明确需求',
						},
						{
							customerName: '李四',
							contactInfo: '13900139000',
							demandTypeDesc: '购买需求',
							leadTypeDesc: '老客户',
							leadSourceDesc: '客户转介绍',
							consumptionWillingness: 2,
							consumptionWillingnessDesc: '中意向',
							clueStatus: 2,
							clueStatusDesc: '已成交',
							followUpRecord: '已确认签约，等待付款',
							followUpPersonId: 102,
							followUpPersonName: '赵销售',
							lastFollowTime: '2026-04-14 09:20:00',
							createPersonName: '王经理',
							createTime: '2026-04-08 11:00:00',
							remarks: '转介绍客户，信任度高',
						},
						{
							customerName: '王五',
							contactInfo: '13700137000',
							demandTypeDesc: '租赁需求',
							leadTypeDesc: '新线索',
							leadSourceDesc: '',
							consumptionWillingness: 1,
							consumptionWillingnessDesc: '低意向',
							clueStatus: 3,
							clueStatusDesc: '已流失',
							followUpRecord: '客户暂无明确需求，暂不考虑',
							followUpPersonId: 103,
							followUpPersonName: '陈销售',
							lastFollowTime: '2026-04-12 16:00:00',
							createPersonName: '刘经理',
							createTime: '2026-04-05 09:30:00',
							remarks: '后续可做二次激活',
						},
						{
							customerName: '赵六',
							contactInfo: '13600136000',
							demandTypeDesc: '购买需求',
							leadTypeDesc: '渠道线索',
							leadSourceDesc: '中介渠道',
							consumptionWillingness: null,
							consumptionWillingnessDesc: '',
							clueStatus: 1,
							clueStatusDesc: '跟进中',
							followUpRecord: '',
							followUpPersonId: 101,
							followUpPersonName: '李销售',
							lastFollowTime: '',
							createPersonName: '王经理',
							createTime: '2026-04-16 15:20:00',
							remarks: '',
						},
						{
							customerName: '孙七',
							contactInfo: '13500135000',
							demandTypeDesc: '租赁需求',
							leadTypeDesc: '新线索',
							leadSourceDesc: '线下活动',
							consumptionWillingness: 3,
							consumptionWillingnessDesc: '高意向',
							clueStatus: 4,
							clueStatusDesc: '已失效',
							followUpRecord: '客户已选择其他项目',
							followUpPersonId: 104,
							followUpPersonName: '周销售',
							lastFollowTime: '2026-04-13 18:10:00',
							createPersonName: '刘经理',
							createTime: '2026-04-07 13:45:00',
							remarks: '竞争对手价格更低',
						},
					],
				},
				followUserList: [], // 跟进人列表
				bulkImportDialogVisible: false, // 批量导入弹窗
			};
		},
		mounted() {
			this.hasSaleManager();
		},
		methods: {
			// 进入页面时判断当前门店下是否有销售主管
			hasSaleManager() {
				// hasSaleManager().then(res => {
				// 	if (!res.flag) {
				// 		// 弹窗提示请前往管理员列表分配销售主管
				// 		if (this.userInfo.hasSuperAdmin) {
				// 			this.$confirm('当前门店未分配销售主管，请前往管理员列表分配销售主管，点击确定进行跳转。', '提示', {
				// 				confirmButtonText: '确定',
				// 				type: 'warning',
				// 			})
				// 				.then(() => {
				// 					this.$router.push({
				// 						path: '/operation/roleManager/adminList',
				// 					});
				// 				})
				// 				.catch(() => {
				// 					this.$router.go(-1);
				// 				});
				// 		} else {
				// 			this.$confirm('当前门店未分配销售主管，请联系管理员分配销售主管。', '提示', {
				// 				confirmButtonText: '确定',
				// 				type: 'warning',
				// 			})
				// 				.then(() => {
				// 					this.$router.go(-1);
				// 				})
				// 				.catch(() => {
				// 					this.$router.go(-1);
				// 				});
				// 		}
				// 	} else {
				// 		this.handleGetAdminList();
				// 		this.getDictList();
				// 		this.isSaleManager();
				// 	}
				// });
			},
			// 判断当前登录人是否为销售主管
			isSaleManager() {
				const rolesNew = this.userInfo.rolesNew;
				if (rolesNew === 1 || this) {
					this.saleManager = true;
				}
			},
			// 最后跟进时间
			handleLastFollowTimeChange(val) {
				this.listPram.lastFollowStartTime = val[0] + ' 00:00:00';
				this.listPram.lastFollowEndTime = val[1] + ' 23:59:59';
			},
			// 线索创建日期
			handleCreateTimeChange(val) {
				this.listPram.createStartTime = val[0] + ' 00:00:00';
				this.listPram.createEndTime = val[1] + ' 23:59:59';
			},
			// 销毁线索
			handlerDestroy(rowData) {
				this.$confirm('确认销毁当前线索', '销毁线索', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					// clueApi.destroyClue({ ids: rowData.id }).then(data => {
					// 	this.$message.success('销毁数据成功');
					// 	this.handleGetAdminList();
					// });
				});
			},
			// 线索失效
			handlerInvalid(rowData) {
				this.$confirm('请您再次确认线索已失效；失效后线索状态无法修改', '线索失效', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					// clueApi.invalidClue({ clueId: rowData.id }).then(data => {
					// 	this.$message.success('修改成功');
					// 	this.handleGetAdminList();
					// });
				});
			},
			// 发起订单
			handlerOpenOrder(rowData) {
				// clueApi.checkOrder({ clueId: rowData.id }).then(res => {
				// 	if (res.orderExist) {
				// 		this.$confirm(
				// 			'系统获取到当前客户线索关联的未发起订单， 是否启用创建时间最邻近的未发起订单？',
				// 			'客户线索存在未发起订单',
				// 			{
				// 				confirmButtonText: '启用未发起订单',
				// 				cancelButtonText: '重新创建订单',
				// 				distinguishCancelAndClose: true, // 区分取消和关闭
				// 				closeOnClickModal: false, // 点击遮罩层不关闭
				// 			}
				// 		)
				// 			.then(() => {
				// 				this.$router.push({
				// 					path: '/contractManagement/create/' + res.orderId,
				// 				});
				// 			})
				// 			.catch(action => {
				// 				// 只有点击"重新创建订单"按钮才跳转，关闭对话框不跳转
				// 				if (action === 'cancel') {
				// 					this.$router.push({
				// 						path: '/contractManagement/create',
				// 						query: {
				// 							res: { ...res, clueId: rowData.id },
				// 						},
				// 					});
				// 				}
				// 			});
				// 	} else {
				// 		// 跳转到创建订单页面
				// 		this.$router.push({
				// 			path: '/contractManagement/create',
				// 			query: {
				// 				res: { ...res, clueId: rowData.id },
				// 			},
				// 		});
				// 	}
				// });
			},
			hideDialogCreate() {
				//新建线索弹框关闭
				this.clueDialogCreateConfig.visible = false;
				this.handleGetAdminList();
			},

			handleSearch() {
				//搜索
				this.listPram.page = 1;
				this.handleGetAdminList();
			},
			resetForm() {
				this.listPram = {
					page: 1,
					limit: this.$constants.page.limit[0],
				};
				this.lastFollowTime = [];
				this.createTime = [];
				this.handleSearch();
			},
			handleSizeChange(val) {
				//分页
				this.listPram.limit = val;
				this.handleGetAdminList();
				this.resetScroll();
			},
			handleCurrentChange(val) {
				//分页
				this.listPram.page = val;
				this.handleGetAdminList();
				this.resetScroll();
			},
			handleGetAdminList() {
				// this.listLoading = true;
				//查询列表
				// clueApi
				// 	.getCluePage(this.listPram)
				// 	.then(data => {
				// 		this.listData = data;
				// 		this.listLoading = false;
				// 	})
				// 	.finally(() => {
				// 		this.listLoading = false;
				// 	});
			},

			handlerOpenAdd(isCreate, editData) {
				//点击编辑按钮，打开抽屉
				this.clueDialogCreateConfig.editData = editData;
				this.clueDialogCreateConfig.isCreate = isCreate;
				this.clueDialogCreateConfig.visible = true;
			},
			bulkImport() {
				this.bulkImportDialogVisible = true;
			},
			handlerOpenDetail(editData, type) {
				//点击详情按钮，打开弹出框
				this.title = type == 0 ? '线索详情' : '客户线索跟进记录';
				this.clueDialogConfig.editData = editData;
				this.clueDialogConfig.type = type;
				this.clueDialogConfig.visible = true;
			},
			hideDialog() {
				//关闭弹出框
				this.clueDialogConfig.visible = false;
				this.handleGetAdminList();
			},
			// 获取回显翻译列表
			async getDictList() {
				this.demandTypeDict = await getDictionaryByCode('DEMAND_TYPE');
				this.consumptionWillingnessDict = await getDictionaryByCode('CONSUMPTION_WILLINGNESS');
				this.leadTypeDict = await getDictionaryByCode('LEAD_TYPE');
				this.clueStatusDict = await getDictionaryByCode('CLUE_NEW_STATUS');
				this.leadSourceDict = await getDictionaryByCode('LEAD_SOURCE');
				// clueApi.adminList().then(data => {
				// 	this.followUserList = data.list;
				// });
			},
			closeBulkImportDialog() {
				this.bulkImportDialogVisible = false;
			},
			handleImportSuccess() {
				this.handleGetAdminList();
			},
			// 根据跟进记录获取标签颜色类型
			getConsumptionWillingnessTagType(code) {
				const colorMap = {
					1: 'info', // 无
					2: 'danger', // 低
					3: 'warning', // 中
					4: 'success', // 高
				};
				return colorMap[String(code)] || 'info';
			},
		},
	};
</script>

<style lang="scss" scoped>
	.el-dialog__wrapper {
		margin-top: -5%;
	}
</style>
